import {
  Container,
  Typography,
  Paper,
} from "@mui/material";
import useCin7Data from "../hooks/useCin7Data";
import ProductCreateView from "../sections/product/view/ProductCreateView";

const ProductCreator = () => {
  const { brands, categories, suppliers, unitsOfMeasure } = useCin7Data();

  return (
    <>
      <Typography variant="body1" sx={{ ml: 3, mt: 3, mr: 5, mb: 1, color: "text.secondary" }}>
        Create a new product and complete all its metadata in a single place. We will automatically send the information to Cin7, Shopify B2C, and Shopify B2B.
      </Typography>

      <Container component="main" maxWidth="100%" sx={{ pb: 3 }}>
        <Paper sx={{ width: "100%", bgcolor: "background.paper", mt: 2, mb: 2, p: 2 }}>
          <ProductCreateView
            brands={brands}
            categories={categories}
            suppliers={suppliers}
            unitsOfMeasure={unitsOfMeasure}
          />
        </Paper>
      </Container>
    </>
  );
};

export default ProductCreator;